import { useState } from 'react';
import { Form, Button, Modal, Alert } from 'react-bootstrap';
import axios from 'axios';
import './Contact.css';

console.log("📢 Contact.js is loaded!");

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [showModal, setShowModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); 

    // Determine backend API base URL
    const API_BASE_URL = process.env.NODE_ENV === "production"
        ? "https://www.freightopstms.com/tms/api/contact"
        : "http://localhost:5000/tms/api/contact";

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setErrorMessage('');
        console.log("🚀 Submit button clicked!");

        try {
            console.log("📡 Sending request to:", API_BASE_URL);
            console.log("📨 Data being sent:", formData);

            const response = await axios.post(API_BASE_URL, formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            console.log("✅ Response received:", response);

            if (response.status === 200) {
                setShowModal(true);
                setFormData({ name: '', email: '', message: '' });
                console.log("🎉 Message sent successfully!");
            }
        } catch (error) {
            console.error("❌ Error sending message:", error);
            setErrorMessage("Failed to send message. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <main className="contact-page">
            <section className="contact-description">
                <h1>Contact Us</h1>

                <p>Need to schedule a demo?</p>
                <p>Have questions about our services?</p>
                <p>We'd love to hear from you! Please fill out the form, and we'll get back to you as soon as possible.</p>
            </section>

            <section className="contact-form-container">
                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formName" className="contact-form-group">
                        <Form.Label>Name</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Enter your name" 
                            name="name" 
                            value={formData.name} 
                            onChange={handleChange} 
                            required
                        />
                    </Form.Group>

                    <Form.Group controlId="formEmail" className="contact-form-group">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control 
                            type="email" 
                            placeholder="Enter your email" 
                            name="email" 
                            value={formData.email} 
                            onChange={handleChange} 
                            required
                        />
                    </Form.Group>

                    <Form.Group controlId="formMessage" className="contact-form-group">
                        <Form.Label>Message</Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={7} 
                            placeholder="Enter your message" 
                            name="message" 
                            value={formData.message} 
                            onChange={handleChange} 
                            required
                        />
                    </Form.Group>

                    <Button 
                        variant="primary" 
                        type="submit" 
                        className="contact-submit-button" 
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "Sending..." : "Submit"}
                    </Button>
                </Form>

                {/* Success Modal */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Message sent successfully!
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowModal(false)}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </section>
        </main>
    );
};

export default Contact;
